import { IConfig } from './IConfig';

const development: IConfig = {
  env: 'development',
  travel: 'https://test-travel.naver.com',
  travelMy: 'https://test-travel.naver.com/my',
  photoInfra: 'https://phinf.pstatic.net/dbscthumb',
  thumbnail: 'https://beta.ssl.phinf.net/search/common?src=',
  cdnDomain: 'https://techminds.pstatic.net',
  flightCdn: {
    url: 'https://techminds.pstatic.net',
    uploadProxyUrl: 'http://nubes-proxy.card.svc.cr2.io.navercorp.com',
  },
  api: {
    airline: 'http://test-airline-api.naver.com',
    flight: 'http://test-flight-api.ssl.naver.com',
    flightBridge: 'http://flight-bridge.flight.svc.cd1.io.navercorp.com',
  },
  biztrip: 'https://dev-biztrip.naver.com',
  bizflight: 'http://dev.store.naver.com:3000/flights',
  flight: 'http://dev.store.naver.com:3000',
  eventpromotion: 'https://test-travel-event.naver.com',
  daBanner: {
    mobile: {
      http: 'http://test-mv.veta.naver.com',
      https: 'https://test-mv.veta.naver.com',
      httpScript:
        'http://tveta.naver.net/libs/assets/js/mo/main/min/mo.veta.core.min.js',
      httpsScript:
        'https://ssl.pstatic.net/tveta/libs/assets/js/mo/main/min/mo.veta.core.min.js',
    },
    pc: {
      http: 'http://test-siape.veta.naver.com',
      https: 'https://test-siape.veta.naver.com',
      loader: 'http://test-img.tveta.naver.net/libs/ndpsdk/test/ndp-loader.js', // sdk 로더
      adUrl: 'http://test-siape.veta.naver.com/fxshow?su=SU14100', // 광고 url
    },
  },
  sentry: {
    flight: {
      enabled: false,
      dsn: 'https://a214300afe86a88dae15cf59b72dd125@test-travel-sentry.ssl.naver.com/5',
      sampleRate: 1,
    },
  },
  nAuthWithUrlParam: 'https://nid.naver.com/nidlogin.login?svctype=262144&url=',
  stamp: 'https://test-travel-event.naver.com/promotion/stamp',
  splugin: {
    mobile: 'https://dev-spi.naver.com/js/release/ko_KR/splugin.m.js',
    pc: 'https://dev-spi.naver.com/js/release/ko_KR/splugin.js',
  },
  ad: {
    nam: {
      scriptUrl: 'https://test-img.tveta.naver.net/libs/glad/test/gfp-core.js',
    },
  },
  ntm: 'https://techminds.pstatic.net/flight/vertical-static/libs/ntm/flight/flight_dev.js',
  maxRollingBannerCount: 7,
};

export default development;
